import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12.5 2.05a8.333 8.333 0 1 0 4.84 4.001m-3.174-1.258h.004M8.75 18.242v-1.837c0-.099.035-.195.1-.27l2.071-2.418a.417.417 0 0 0-.11-.633l-2.38-1.36a.4.4 0 0 1-.155-.155L6.725 8.85a.42.42 0 0 0-.4-.208l-4.605.41m15.78-4.05c0 1.84-1.667 3.333-3.334 5-1.667-1.667-3.333-3.16-3.333-5a3.333 3.333 0 0 1 6.666 0m-3.126-.209a.208.208 0 1 1-.416 0 .208.208 0 0 1 .416 0"
    }, null, -1)
  ])))
}
export default { render: render }